// import { canUseDOM } from 'exenv';

export function tagPageLoading(resp = {}, store = {}) {
  return {
    type: 'TAG_PAGE_LOADING',
    tagPage: resp,
    store
  };
}

export function tagPageLoaded(resp = {}, store = {}) {
  return {
    type: 'TAG_PAGE_LOADED',
    tagPage: resp,
    store
  };
}

export function tagPageLoadError(error, store = {}) {
  return {
    type: 'TAG_PAGE_ERROR',
    tagPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
